module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-field', {
    attrs: {
      "label": "Select datetime"
    }
  }, [_c('b-datetimepicker', {
    attrs: {
      "placeholder": "Click to select...",
      "min-datetime": _vm.minDatetime,
      "max-datetime": _vm.maxDatetime
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cb39088"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/datetimepicker/examples/ExRange.vue
// module id = 1052
// module chunks = 18 139